module.exports = __webpack_public_path__ + "media/images/ellii-logo-rgb-yellow-bulb-d0ed57d8.svg";